import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { gapiLoaded } from 'src/services/gapi/actions';
import { setCookie } from 'src/utils';

export const SESSION_TIMEOUT = 60 * 60 * 1000;
export const AUTH_HEADER = 'Authorization';

class Init extends PureComponent {
  componentDidMount() {
    this.initGapi();
  }

  initGapi = () => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";

    script.onload = () => {
        this.props.gapi.loaded();

        window.client = window.google.accounts.oauth2.initTokenClient({
          client_id: window.conf.c1,
          // Scopes to request in addition to 'profile' and 'email', e.g.
          // scope: 'https://www.googleapis.com/auth/cloudplatformprojects.readonly',
          scope: 'email profile openid',
          callback: this.onLogin
        });

         this.checkUserAuthorized(false);
    };

    document.body.appendChild(script);
  };

  onLogin = (resp) => {
    setCookie(AUTH_HEADER, `Bearer%20${resp.access_token}`, SESSION_TIMEOUT);
    this.checkUserAuthorized(true);
    return false
  }

  checkUserAuthorized = (doReload) => {
   console.log("checkUserAuthorized")
   fetch('/api/session', {
     headers: { 'Content-Type': 'application/json; charset=utf-8' },
     credentials: 'include',
   }).then((response) => {
       if (response.ok) {
         return response.json();
       }
       console.log("error", response)
      return null
     })
     .then((responseJson) => {
         if (responseJson) {
              console.log("authorized", responseJson)
              window.userProfile = responseJson
              if (doReload) {
                 window.location.reload(true);
              }
         }
     })

     return false
 }

  render() {
    return null;
  }
}

Init.propTypes = {
  gapi: PropTypes.shape({
    loaded: PropTypes.func.isRequired,
  }).isRequired,
};

const mapDispatchToProps = dispatch => ({
  gapi: bindActionCreators({ loaded: gapiLoaded }, dispatch),
});

export default connect(null, mapDispatchToProps)(Init);
